// extracted by mini-css-extract-plugin
module.exports = {"container":"WeekdayCalendar_container__2-Frd","badge":"WeekdayCalendar_badge__Cz4o2"};